function Tooltip(element, {position = "top"} = {}) {
	if (!element) {
		return;
	}

	const positions = ["top", "right", "bottom", "left"];

	const pos = positions.includes(position) ? position : positions[0];

	const trigger = element.querySelector('[data-tooltip-trigger]');
	const content = element.querySelector('[data-tooltip-content]');

	const liveRegion = document.createElement('div');
	liveRegion.role = "status";
	element.appendChild(liveRegion);

	if (!trigger || !content || !liveRegion) {
		return;
	}

	const message = content.innerHTML;
	const isOpen = () => !!(liveRegion.innerHTML); 
	
	const closeToggleTip = () => {
		liveRegion.innerHTML = '';
		liveRegion.removeAttribute('style');
	}

	const openToggleTip = () => {
		window.setTimeout(function() {
			if (!isOpen()) {
				liveRegion.innerHTML = `<div class="c-content c-tooltip__bubble c-tooltip__bubble--${pos}">${message}</div>`;
				const {left, top, right, bottom} = liveRegion.firstElementChild.getBoundingClientRect();
				liveRegion.style.setProperty(
					"--tooltip-bubble-left",
					`${left < 0 ? Math.abs(left) + 16 : right > window.innerWidth ? window.innerWidth - right - 16 : 0}px`
				);
				liveRegion.style.setProperty(
					"--tooltip-bubble-top",
					`${top < 0 ? Math.abs(top) : bottom > window.innerHeight ? window.innerHeight - bottom : 0}px`
				);
			}
		}, 100);
	}

	// Toggle the message
	trigger.addEventListener('click', () => {
		closeToggleTip();
		openToggleTip();
	});


	// Remove toggletip on ESC
	element.addEventListener('keyup', ({key}) => {
		if ( key === "Escape") {
			closeToggleTip();
		}
	});

	// Remove on focusout
	element.addEventListener('focusout', () => {
		window.setTimeout(function() {
			if (!element.contains(document.activeElement)) {
				closeToggleTip();
			}
		}, 40);
	});
};

export default Tooltip;